import { motion, AnimatePresence, useScroll, useMotionValueEvent } from "framer-motion";
import { useState } from "react";

const FloatingCTA = () => {
    const [visible, setVisible] = useState(false);
    const { scrollY } = useScroll();

    useMotionValueEvent(scrollY, "change", (latest) => {
        const doc = document.documentElement;
        const nearBottom = latest + window.innerHeight > doc.scrollHeight - 900;
        setVisible(latest > 600 && !nearBottom);
    });

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ opacity: 0, y: 30, scale: 0.95 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 30, scale: 0.95 }}
                    transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
                    data-testid="floating-cta"
                    className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-40"
                >
                    <a
                        href="https://calendly.com/d/d3nd-zhb-2fr/lexafide-demo-discussion-30-minute-meeting-web"
                        target="_blank"
                        rel="noreferrer"
                        data-testid="floating-cta-btn"
                        className="btn-primary inline-flex items-center gap-2.5 text-sm pl-5 pr-6"
                    >
                        <span className="relative flex h-2 w-2">
                            <span className="absolute inline-flex h-full w-full rounded-full bg-[var(--paper)] opacity-75 animate-ping" />
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-[var(--paper)]" />
                        </span>
                        <i className="fa-solid fa-calendar-check text-xs" />
                        Book a demo
                    </a>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default FloatingCTA;
